import { Line } from "react-chartjs-2";
import { CategoryScale, Chart, LinearScale, PointElement, LineElement, Tooltip, Legend, Colors, ChartData, } from "chart.js";
import { Box, Typography } from "@mui/material";

Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Colors);

interface AreaChartProps {
    chartData: ChartData<"line", number[], unknown>;
    title?: string;
}

export const AreaChart = ({
    chartData,
    title = "",
}: AreaChartProps) => (
    <Box sx={{ marginTop: 2, width: "500px" }}>
        <Typography variant="h6" sx={{ textAlign: "center" }}>
            {title}
        </Typography>
        <Line
            data={chartData}
            options={{
                scales: { y: { beginAtZero: true } },
                plugins: {
                    title: {
                        display: true
                    },
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true
                    },
                },
            }}
        />
    </Box>
);